import { render, staticRenderFns } from "./Phishlabs.vue?vue&type=template&id=8be467d4&"
import script from "./Phishlabs.vue?vue&type=script&lang=js&"
export * from "./Phishlabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports